export enum NightCallBillRateTypeEnum {
    PerHour = 1,
    PerShift = 2
}
